import { render, staticRenderFns } from "./IndexFinished.vue?vue&type=template&id=6b25d68a&scoped=true&"
import script from "./IndexFinished.vue?vue&type=script&lang=js&"
export * from "./IndexFinished.vue?vue&type=script&lang=js&"
import style0 from "./IndexFinished.vue?vue&type=style&index=0&id=6b25d68a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b25d68a",
  null
  
)

export default component.exports